import { render, staticRenderFns } from "./ManagePerformanceParticipants.vue?vue&type=template&id=3ca44c53"
import script from "./ManagePerformanceParticipants.vue?vue&type=script&lang=js"
export * from "./ManagePerformanceParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports